import { Grid2 } from "@mui/material";
import InnerLink from "../InnerLink";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import classes from './index.module.scss';

const NavigatorArrows = ({
  leftLink,
  rightLink,
}) => {
  return (
    <Grid2 container size={12} className={classes.container}>
      {
        leftLink ? (
          <Grid2 className={classes.leftLink}>
            <InnerLink href={leftLink.href} noUnderline>
              <ArrowBackIosIcon className={classes.icon} />
              {
                leftLink.title
              }
            </InnerLink>
          </Grid2>
        ) : null
      }
      {
        rightLink ? (
          <Grid2 className={classes.rightLink}>
            <InnerLink href={rightLink.href} noUnderline>
              {
                rightLink.title
              }
              <ArrowForwardIosIcon className={classes.icon} />
            </InnerLink>
          </Grid2>
        ) : null
      }
    </Grid2>
  )
}

export default NavigatorArrows;